import { render, staticRenderFns } from "./EditorNewDiscussionButton.vue?vue&type=template&id=f4f2fafa&"
import script from "./EditorNewDiscussionButton.vue?vue&type=script&lang=js&"
export * from "./EditorNewDiscussionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditorNewDiscussionButton.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/gutters/EditorNewDiscussionButton.vue
// module id = 2310
// module chunks = 1